import Configs from 'config';

// when do any change to ToggleNames, please update this page:
// https://myobconfluence.atlassian.net/wiki/spaces/PSSOE/pages/1279922151/Generic+feature+toggle+functions+that+support+override
export enum ToggleNames {
    LOAD_REDUX_DEVTOOLS = 'LOAD_REDUX_DEVTOOLS',
    FEATURE_PRODUCT_MANAGEMENT = 'FEATURE_PRODUCT_MANAGEMENT',
    FEATURE_CHECKOUT_ACTIONS = 'FEATURE_CHECKOUT_ACTIONS',
    FEATURE_SSP_ACTIONS = 'FEATURE_SSP_ACTIONS',
    FEATURE_AVOID_INVALID_ERROR_TRACK = 'FEATURE_AVOID_INVALID_ERROR_TRACK',
}

export function getValueFromCookie(name: string): string | null {
    const namePlusEqual = name + '=';
    const cookie = decodeURIComponent(document.cookie);
    const ca = cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        c = c.trim();
        if (c.indexOf(namePlusEqual) === 0) {
            return c.substring(namePlusEqual.length, c.length);
        }
    }
    return null;
}

export function getFeatureToggle(toggleName: ToggleNames): boolean {
    const toggleInCookie = getValueFromCookie(toggleName);
    if (toggleInCookie) {
        return toggleInCookie === 'true';
    } else {
        return Configs.FEATURE_TOGGLES[toggleName];
    }
}
